import { defineCollection } from "@rebasepro/common";
/**
 * Never contact these. Checked twice: before a draft is written, and again
 * inside the send endpoint immediately before delivery.
 *
 * Checked twice on purpose. A draft written yesterday and approved today may
 * have been superseded by an opt-out in between, and the check that matters is
 * the one closest to the irreversible act. The first check only saves the model
 * the work.
 *
 * A row may suppress a single address or a whole domain — `value` holds either,
 * and `kind` says which. Adding one is always safe and never needs a reason,
 * which is why `reason` is optional: a suppression that someone hesitates to
 * add because the form demands justification is a suppression that does not
 * exist when it is needed.
 */
const suppressionsCollection = defineCollection({
    name: "Suppressions",
    singularName: "Suppression",
    slug: "suppressions",
    table: "suppressions",
    description: "Do-not-contact list. Checked before drafting and again before sending.",
    properties: {
        id: { name: "ID", type: "string", isId: "uuid", admin: { readOnly: true } },
        value: {
            name: "Address or domain",
            type: "string",
            validation: { required: true, unique: true },
            description: "someone@example.com, or example.com to suppress everyone there"
        },
        kind: {
            name: "Kind",
            type: "string",
            validation: { required: true },
            defaultValue: "email",
            enum: [
                { id: "email", label: "Single address", color: "blue" },
                { id: "domain", label: "Whole domain", color: "purple" }
            ]
        },
        reason: {
            name: "Reason",
            type: "string",
            enum: [
                { id: "opted_out", label: "Asked not to be contacted", color: "red" },
                { id: "bounced", label: "Bounced", color: "orange" },
                { id: "competitor", label: "Competitor", color: "gray" },
                { id: "customer", label: "Already a customer", color: "green" },
                { id: "other", label: "Other", color: "gray" }
            ]
        },
        notes: { name: "Notes", type: "string", admin: { multiline: true } },
        created_at: { name: "Added", type: "date", autoValue: "on_create", admin: { readOnly: true } }
    },
    admin: {
        icon: "Block",
        group: "Outreach",
        defaultViewMode: "table",
        enabledViews: ["table", "list"],
        display: {
            title: "value"
        },
        sort: ["created_at", "desc"],
        propertiesOrder: ["value", "kind", "reason", "notes", "created_at"]
    }
});
export default suppressionsCollection;
